import kebabCase from 'lodash/kebabCase';
import get from 'lodash/get';
import styled from 'styled-components';
export const createComponent = ({
  name,
  tag = 'div',
  as,
  style,
  props: getBaseProps = () => ({})
}) => {
  const component = styled(as || tag);
  return component.attrs(props => {
    const baseProps = getBaseProps(props);
    const finalProps = { ...baseProps,
      ...props,
      className: baseProps.className || props.className
    };
    return { ...finalProps,
      className: getComponentClassName(finalProps, kebabCase(name))
    };
  })`
  ${style}
  ${getComponentStyle(name)}
  ${p => getVariantStyles(name, p.variant)}
  ${({
    styles = {}
  }) => styles[name] || {}}
`;
};

const getComponentClassName = ({
  className,
  theme: {
    classPrefix
  },
  variant
}, name) => `${className || ''} ${classPrefix}-${name} ${variant ? `${classPrefix}-${name}-${variant}` : ''}`.trim();

const themeGet = (lookup, fallback) => ({
  theme
} = {}) => get(theme, lookup, fallback);

const getComponentStyle = componentName => themeGet(`styles.${componentName}`, {});

const getVariantStyles = (componentName, variant) => themeGet(`variants.${componentName}.${variant}.style`, {});